import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { warehouseexecApi, type WarehouseDashboard } from '../../api/warehouseexec';

const NAV = [
  { to: '/warehouse/picking', label: 'Picking' },
  { to: '/warehouse/packing', label: 'Packing' },
  { to: '/warehouse/dispatch', label: 'Dispatch' },
  { to: '/warehouse/docks', label: 'Docks' },
  { to: '/warehouse/workers', label: 'Workers' },
  { to: '/warehouse/waves', label: 'Wave planner' },
  { to: '/warehouse/kpis', label: 'KPIs' },
  { to: '/warehouse/mobile', label: 'Mobile scanner' },
];

export function WarehouseHubPage() {
  const [dashboard, setDashboard] = useState<WarehouseDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void warehouseexecApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Active jobs', value: dashboard.active_jobs },
        { label: 'Pending picks', value: dashboard.pending_picks },
        { label: 'Active packs', value: dashboard.active_packs },
        { label: 'Dispatch queue', value: dashboard.dispatch_queue },
        { label: 'Workers active', value: dashboard.workers_active },
        { label: 'Packing accuracy', value: `${(dashboard.packing_accuracy * 100).toFixed(1)}%` },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Warehouse Execution</h1>
      <p className="mt-1 text-sm text-slate-600">Enterprise WES — fulfilment, picking, packing and dispatch.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
